export default __webpack_public_path__ + "static/media/rating_8.86e22d68.png";